export default "__VITE_PUBLIC_ASSET__625b6e99__"